import {LinkButton} from '@components/common/base/buttons'
import React from 'react'
import {Lang} from 'yougile-lang'

export const ShowMore = <T,>({
  list,
  maxShow,
  handler
}: {
  list: T[]
  maxShow: number
  handler: (e: React.MouseEvent) => void
}) => {
  if (list.length - maxShow > 0) {
    return (
      <LinkButton
        onClick={handler}
        size="small"
        icon="IconDotsCircleHorizontal"
      >
        {Lang.msg.showMore2} (+{list.length - maxShow})
      </LinkButton>
    )
  }
  return null
}
